import React from 'react';

import classnames from 'classnames';

import { CheckIconWithPadding, EvIcon } from '@evinced-private/ui-common';

import { OptionType } from '../../NavigationMenu';

import './NavigationMenuOption.scss';

interface NavigationMenuOptionProps {
	option: OptionType;
	index: number;
	isSelected: boolean;
	isFocused: boolean;
	onSelect: (option: OptionType) => void;
	onMouseEnter: (index: number) => void;
	listboxId: string;
}

export const NavigationMenuOption: React.FC<NavigationMenuOptionProps> = ({
	option,
	index,
	isSelected,
	isFocused,
	onSelect,
	onMouseEnter,
	listboxId
}) => {
	return (
		<li
			role="none"
			className={classnames('navigation-menu__option', {
				'navigation-menu__option--selected': isSelected,
				'navigation-menu__option--focused': isFocused
			})}
		>
			<button
				id={`${listboxId}-option-${index}`}
				type="button"
				className="navigation-menu__option-link"
				tabIndex={-1}
				aria-current={isSelected ? 'page' : undefined}
				aria-label={`${option.label}${isSelected ? ', currently selected business unit' : ', business unit'}`}
				onClick={(e) => {
					e.preventDefault();
					onSelect(option);
				}}
				onMouseEnter={() => onMouseEnter(index)}
			>
				<span className="navigation-menu__option-text">{option.label}</span>
				{isSelected && <EvIcon icon={CheckIconWithPadding} aria-hidden="true" small />}
			</button>
		</li>
	);
};
